var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white border-t mt-2"},[_c('div',{staticClass:"max-w-screen-xl mx-auto pt-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }